(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brass-frame-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    function detailPanel(hash) {
      if (!hash.startsWith('#brass-finish-') && !hash.startsWith('#brass-order-')) return;
      const panel = document.getElementById(hash.slice(1));
      if (panel?.matches('details[data-brass-finish], details[data-brass-making]')) return panel;
    }
    function revealFromLocation() {
      const panel = detailPanel(window.location.hash);
      if (!panel) return;
      panel.open = true;
      panel.scrollIntoView({block: 'start'});
    }
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.('a[data-brass-finish-link], a[data-brass-detail-link]');
      const panel = link && detailPanel(link.hash);
      if (!panel) return;
      panel.open = true;
      panel.querySelector('summary').focus({preventScroll: true});
    });
    window.addEventListener('hashchange', revealFromLocation);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealFromLocation, {once:true});
    else revealFromLocation();
  })();

  (() => {
    const selector = '[data-brass-arrival]';
    let midnightTimer;
    function renderArrival(panel, today) {
      const choice = panel.closest('.product')?.querySelector('brass-customizer [data-production]:checked');
      const speed = choice?.dataset.production || panel.dataset.defaultSpeed;
      const [makeMin, makeMax] = (speed === 'rush' ? panel.dataset.rush : panel.dataset.standard).split(',').map(Number);
      // Advance the shopper’s local calendar at noon so DST never skips or repeats an arrival date.
      const after = days => new Date(today.getFullYear(), today.getMonth(), today.getDate() + days, 12);
      const first = after(makeMin + Number(panel.dataset.otherMin));
      const last = after(makeMax + Number(panel.dataset.otherMax));
      const year = last.getFullYear() === today.getFullYear() ? undefined : 'numeric';
      const format = new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', year});
      const range = format.formatRange ? format.formatRange(first, last) : format.format(first) + ' – ' + format.format(last);
      const note = 'After design approval: ' + makeMin + '–' + makeMax + ' days to make.';
      const dateText = panel.querySelector('[data-brass-arrival-range]');
      const makeText = panel.querySelector('[data-brass-make-note]');
      if (dateText.textContent !== range) dateText.textContent = range;
      if (makeText.textContent !== note) makeText.textContent = note;
    }
    function refreshAll() {
      clearTimeout(midnightTimer);
      const panels = document.querySelectorAll(selector);
      if (!panels.length) return;
      const today = new Date();
      panels.forEach(panel => renderArrival(panel, today));
      const midnight = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
      midnightTimer = setTimeout(refreshAll, midnight - today + 100);
    }
    document.addEventListener('change', e => {
      if (!e.target.matches?.('brass-customizer [data-production]')) return;
      const panel = e.target.closest('.product')?.querySelector(selector);
      if (panel) renderArrival(panel, new Date());
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAll, {once:true});
    else refreshAll();
    window.addEventListener('pageshow', refreshAll);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshAll(); });
    document.addEventListener('shopify:section:load', refreshAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brass-product-information"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#brass-order-"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (target && target.matches('details[data-brass-making]')) target.open = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brass-story"] && !Shopify.designMode) return;
  try {
    (() => {
    function initFamilyNotes(scope) {
      scope.querySelectorAll('[data-family-notes]').forEach(root => {
        if (root.dataset.notesReady) return;
        root.dataset.notesReady = 'true';
        const track = root.querySelector('.brass-family-notes__track');
        const controls = root.querySelector('.brass-family-notes__controls');
        const previous = root.querySelector('[data-note-prev]');
        const next = root.querySelector('[data-note-next]');
        function update() {
          const maximum = track.scrollWidth - track.clientWidth;
          controls.hidden = maximum <= 2;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maximum - 2;
        }
        function move(direction) {
          const card = track.querySelector('li');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const distance = card.getBoundingClientRect().width + gap;
          track.scrollBy({left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive:true});
        new ResizeObserver(update).observe(track);
        update();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFamilyNotes(document), {once:true});
    else initFamilyNotes(document);
    document.addEventListener('shopify:section:load', event => initFamilyNotes(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["portrait-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('portrait-comparison')) {
    customElements.define('portrait-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const range = this.querySelector('input');
        const stage = this.querySelector('.portrait-comparison__stage');
        const update = () => this.style.setProperty('--comparison-position', `${range.value}%`);
        const move = (event) => {
          const rect = stage.getBoundingClientRect();
          range.value = Math.round(Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100)));
          update();
        };
        let pointerId = null;
        range.hidden = false;
        range.addEventListener('input', update);
        range.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          event.preventDefault();
          pointerId = event.pointerId;
          range.focus({ preventScroll: true });
          range.setPointerCapture(pointerId);
          move(event);
        });
        range.addEventListener('pointermove', (event) => {
          if (event.pointerId === pointerId) move(event);
        });
        const stop = () => { pointerId = null; };
        range.addEventListener('pointerup', stop);
        range.addEventListener('pointercancel', stop);
        range.addEventListener('lostpointercapture', stop);
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-reviews')) {
    customElements.define('product-reviews', class extends HTMLElement {
      connectedCallback() {
        const widget = this.querySelector('.jdgm-review-widget');
        if (!widget) return;
        this.resizeObserver = new ResizeObserver(() => {
          this.toggleAttribute('data-ready', widget.getBoundingClientRect().height > 0);
        });
        this.resizeObserver.observe(widget);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
